module.exports = __webpack_public_path__ + "img/background.bbcc0d1b.png";